module.exports = {"footer":"","title":"Satzung"};